import { useQuery } from "@tanstack/react-query";
import { useApi } from "./api";
import type { BusinessAccess, BusinessCapability } from "@payangel/shared";
export function usePermissions(enabled = true) {
  const api = useApi();
  const query = useQuery({
    queryKey: ["permissions-me"],
    queryFn: () =>
      api.get<{
        permissions: string[];
        accessPending?: boolean;
        businessAccess: BusinessAccess | null;
        nativeCapacity?: { view: boolean; manage: boolean };
      }>("/permissions/me"),
    enabled,
    refetchInterval: 30000,
    staleTime: 0,
    retry: false,
  });
  return {
    ...query,
    businessAccess: query.data?.businessAccess,
    nativeCapacity: !query.isError && Boolean(query.data?.nativeCapacity?.view),
    businessCan: (capability: BusinessCapability, legacy = false) =>
      !query.isError &&
      !query.isPending &&
      (query.data?.businessAccess
        ? query.data.businessAccess.capabilities.includes(capability)
        : legacy),
    can: (name: string) =>
      !query.isError && Boolean(query.data?.permissions.includes(name)),
  };
}
